import { useEffect } from "react"
import toast from "react-hot-toast"
import { Outlet, useNavigate } from "react-router-dom"
import { logInPath } from "~/common/paths"
import useScrollToTop from "~/hooks/useScrollToTop"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"

export const RequireUserSignedIn = () => {
  useScrollToTop()
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()

  useEffect(() => {
    if (!currentUser && !result.loading) {
      toast.error("Please sign in to continue.")
      navigate(logInPath.pattern)
    }
  })

  if (result.loading) {
    return null
  }

  return <>{currentUser && <Outlet />}</>
}
